export const formatNum = (amount, decimals = 18) => {
  const formattedNum = Number(amount).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
  if (formattedNum === "NaN") {
    return "--";
  }
  return formattedNum;
};

